<template>
    <div>
        <Row :gutter="16">
            <i-col :xs="12">
                <span class="card-title-top" style="border-bottom: 0;">Painel Geral de Desenvolvimento <Badge
                        :count="tickets_pgd.length" overflow-count="9999" type="primary"/></span>
                <TableDraggable :columns="pgd_colunas" :data-items="tickets_pgd"
                                :get-child-payload="getChildPgd" :group-name="'1'"
                                no-sort :tableWidth="600" @drop="onDrop('tickets_pgd', $event)" :offsetTop="235" />
            </i-col>
            <i-col :xs="12">
                <span class="card-title-top" style="margin-bottom: 20px;">
					<i-form label-position="top">
						<form-item>
							<i-input @input="searchDelay" placeholder="Pesquisar" size="large"></i-input>
						</form-item>
					</i-form>
                </span>
                <Tabs :animated="false" class="quarentena">
                    <TabPane :label="labels.mel" :style="{overflowX: 'auto'}" icon="ios-star">
                        <TableDraggable :columns="pgd_mel_colunas" :data-items="tickets_quarentena_mel"
                                        :get-child-payload="getTicketQuarentenaMel" :group-name="'1'"
                                        no-sort :onSort="(...data) => onSort('tickets_quarentena_mel', ...data)"
                                        :defaultOrder="defaultOrder.tickets_quarentena_mel"
                                        :tableWidth="600" @drop="onDrop('tickets_quarentena_mel', $event)"
                                        :offsetTop="342" @scrollEnd="loadMore('tickets_quarentena_mel')" />
                    </TabPane>
                    <TabPane :label="labels.mvp" :style="{overflowX: 'auto'}" icon="ios-flash">
                        <TableDraggable :columns="pgd_mvp_colunas" :data-items="tickets_quarentena_mvp"
                                        :get-child-payload="getTicketQuarentenaMvp" :group-name="'1'"
                                        no-sort :tableWidth="600"
                                        @drop="onDrop('tickets_quarentena_mvp', $event)"
                                        :offsetTop="342" @scrollEnd="loadMore('tickets_quarentena_mvp')" />
                    </TabPane>
                </Tabs>
            </i-col>
        </Row>
        <DrawerTicket v-model="edit_pgd" :id="edit_id" @update="onTicketUpdate"></DrawerTicket>
        <!-- componete para descrever a alteração do andamento
            @param andamento dados do ticket em alteração
            @ref button para ter acesso nas variveis do comeponete filho
            @value show_andamento para exibir o componete
            @emit chama uma função parta tratar os dados recebidos
         -->
        <DrawerAndamento ref="drawer" :andamento="andamento" v-model="show_andamento"
                          v-on:update="updateAndamento" :carregar="carregar">
        </DrawerAndamento>
    </div>
</template>

<script>
    import accounting from 'accounting';
    import _ from 'lodash';
    import {moment} from '../../helpers/utils';
    import ticketMixin from '../../mixins/ticket';
    export default {
        components: {
            DrawerTicket: () => import("./components/Drawer.vue"),
            Container: () =>
                import("vue-smooth-dnd").then(({Container}) => Container),
            Draggable: () =>
                import("vue-smooth-dnd").then(({Draggable}) => Draggable),
            DrawerAndamento: () => import("./components/drawer-pgd-form-causas.vue")
        },
        name: "tickets-quarentena",
        mixins: [ticketMixin],
        data() {
            return {
                filtro: {
                    search: "",
                },
                edit_pgd: false,
                edit_id: 0,
                pgd_colunas: [
                    {
                        title: "Tipo",
                        width: 95,
                        render: (h, params) => {
                            return h("Icon", {
                                props: {
                                    ...this.getIconTicket(params.row.tipo_id, params.row.criticidade || 0)
                                },
                                style: {
                                    fontSize: "35px"
                                }
                            });
                        }
                    },
                    {
                        title: "#",
                        key: "id_ticket",
                        width: 100,
                        render: (h, params) => {
                            return h({
                                template: `<span class="content-column">
                                    <Tooltip placement="top" style="font-size:11px" content="ID Ticket">
                                        <Tag class="tag-ticket">${params.row.id_ticket}</Tag>
                                    </Tooltip>
                                    <Tooltip v-if="${params.row.movidesk_id}" placement="top" style="font-size:11px" content="ID Movidesk">
                                        <Tag class="tag-ticket">${params.row.movidesk_id}</Tag>
                                    </Tooltip>
                                </span>`
                            });
                        }
                    },
                    {
                        title: "Resumo",
                        key: "resumo",
                        render: (h, params) => {
                            return h(
                                "div",
                                {
                                    style: {
                                        fontSize: "16px"
                                    }
                                },
                                [
                                    h(
                                        "a",
                                        {
                                            attrs: {
                                                class: "table-edit"
                                            },
                                            on: {
                                                click: () =>
                                                    this.editTicket(
                                                        params.row.id_ticket
                                                    )
                                            }
                                        },
                                        [
                                            params.row.resumo,
                                            h("Icon", {
                                                props: {
                                                    type: "md-create"
                                                }
                                            })
                                        ]
                                    )
                                ]
                            );
                        }
                    },
                    {
                        title: "Prazo",
                        key: "data_hora_cadastro",
                        width: 100,
                        render: (h, params) => {
                            return h(
                                "div",
                                moment(params.row.data_hora_cadastro).format(
                                    "DD/MM/YYYY"
                                )
                            );
                        }
                    },
                    {
                        title: " ",
                        width: 58,
                        render: (h, params) => {
                            if (params.row.tipo_id === 45 || (params.row.andamento >= 1 || params.row.associacoes_count > 0)) {
                                return;
                            }
                            return h("VxOptions", {
                                attrs: {
                                    id: params.row.id_ticket,
                                    onSelect: this.opcaoTicket,
                                    options: [
                                        {
                                            icone: "md-close",
                                            label: "Fechar",
                                            textColor: "#ff5252",
                                            show: true,
                                        },
                                        {
                                            icone: "ios-git-merge",
                                            label: "Associar",
                                            textColor: "#00bcd4",
                                            show: true,
                                        }
                                    ],
                                }
                            });
                        }
                    }
                ],
                pgd_quar_colunas: [
                    {
                        title: "#",
                        key: "id_ticket",
                        width: 100,
                        sortable: true,
                        render: (h, params) => {
                            return h({
                                template: `<span class="content-column">
                                    <Tooltip placement="top" style="font-size:11px" content="ID Ticket">
                                        <Tag class="tag-ticket">${params.row.id_ticket}</Tag>
                                    </Tooltip>
                                    <Tooltip v-if="${params.row.movidesk_id}" placement="top" style="font-size:11px" content="ID Movidesk">
                                        <Tag class="tag-ticket">${params.row.movidesk_id}</Tag>
                                    </Tooltip>
                                </span>`
                            });
                        }
                    },
                    {
                        title: "Resumo",
                        key: "resumo",
                        sortable: true,
                        render: (h, params) => {
                            return h(
                                "div",
                                {
                                    style: {
                                        fontSize: "16px"
                                    }
                                },
                                [
                                    h(
                                        "a",
                                        {
                                            attrs: {
                                                class: "table-edit"
                                            },
                                            on: {
                                                click: () =>
                                                    this.editTicket(
                                                        params.row.id_ticket
                                                    )
                                            }
                                        },
                                        [
                                            params.row.resumo,
                                            h("Icon", {
                                                props: {
                                                    type: "md-create"
                                                }
                                            })
                                        ]
                                    )
                                ]
                            );
                        }
                    },
                    {
                        title: "Prazo",
                        key: "data_hora_cadastro",
                        width: 100,
                        sortable: true,
                        render: (h, params) => {
                            return h(
                                "div",
                                moment(params.row.data_hora_cadastro).format(
                                    "DD/MM/YYYY"
                                )
                            );
                        }
                    },
                    {
                        title: " ",
                        width: 58,
                        render: (h, params) => {
                            return h("VxOptions", {
                                attrs: {
                                    id: params.row.id_ticket,
                                    onSelect: this.opcaoTicket,
                                    options: [
                                        {
                                            icone: "ios-git-merge",
                                            label: "Associar",
                                            textColor: "#00bcd4",
                                            show: true,
                                        },
                                        {
                                            icone: "md-close",
                                            label: "Fechar",
                                            textColor: "#ff5252",
                                            show: true,
                                        }
                                    ]
                                }
                            });
                        }
                    }
                ],
                pgd_mel_colunas: [
                    {
                        title: "#",
                        key: "id_ticket",
                        width: 100,
                        sortable: true,
                        render: (h, params) => {
                            return h({
                                template: `<span class="content-column">
                                    <Tooltip placement="top" style="font-size:11px" content="ID Ticket">
                                        <Tag class="tag-ticket">${params.row.id_ticket}</Tag>
                                    </Tooltip>
                                    <Tooltip v-if="${params.row.movidesk_id}" placement="top" style="font-size:11px" content="ID Movidesk">
                                        <Tag class="tag-ticket">${params.row.movidesk_id}</Tag>
                                    </Tooltip>
                                </span>`
                            });
                        }
                    },
                    {
                        title: "Resumo",
                        key: "resumo",
                        sortable: true,
                        render: (h, params) => {
                            return h(
                                "div",
                                {
                                    style: {
                                        fontSize: "16px"
                                    }
                                },
                                [
                                    h(
                                        "a",
                                        {
                                            attrs: {
                                                class: "table-edit"
                                            },
                                            on: {
                                                click: () =>
                                                    this.editTicket(
                                                        params.row.id_ticket
                                                    )
                                            }
                                        },
                                        [
                                            params.row.resumo,
                                            h("Icon", {
                                                props: {
                                                    type: "md-create"
                                                }
                                            })
                                        ]
                                    )
                                ]
                            );
                        }
                    },
                    {
                        title: "Prazo",
                        key: "data_hora_cadastro",
                        width: 100,
                        sortable: true,
                        render: (h, params) => {
                            return h(
                                "div",
                                moment(params.row.data_hora_cadastro).format(
                                    "DD/MM/YYYY"
                                )
                            );
                        }
                    },
                    {
                        title: "Tela",
                        key: "tela_ux",
                        width: 80,
                        sortable: true,
                        render: (h, params) => {
                            return h(
                                "a",
                                {
                                    on: {
                                        click: () =>
                                            this.pgdTelaUx(params.row.id_ticket)
                                    }
                                },
                                [
                                    h("Icon", {
                                        props: {
                                            type:
                                                params.row.tela_ux == 1
                                                    ? "ios-color-palette"
                                                    : "ios-color-palette-outline"
                                        },
                                        style: {
                                            fontSize: "22px",
                                            color: "#515a73"
                                        }
                                    })
                                ]
                            );
                        }
                    },
                    {
                        title: "Gestão",
                        key: "analise_gestao",
                        width: 99,
                        sortable: true,
                        render: (h, params) => {
                            return h("a", {
                                style: {
                                    marginLeft: "10px"
                                },
                                attrs: {
                                    class:
                                        params.row.analise_gestao == 1
                                            ? "circle-radio-checked"
                                            : "circle-radio"
                                },
                                on: {
                                    click: () =>
                                        this.pgdAnaliseGestao(params.row.id_ticket)
                                }
                            });
                        }
                    },
                    {
                        title: "Mensal.",
                        key: "valor_mensalidades",
                        width: 104,
                        sortable: true,
                        render: (h, params) => {
                            return h(
                                "span",
                                accounting.formatNumber(
                                    params.row.valor_mensalidades,
                                    2,
                                    ".",
                                    ","
                                )
                            );
                        }
                    },
                    {
                        title: " ",
                        width: 58,
                        render: (h, params) => {
                            return h("VxOptions", {
                                attrs: {
                                    id: params.row.id_ticket,
                                    onSelect: this.opcaoTicket,
                                    options: [
                                        {
                                            icone: "md-close",
                                            label: "Fechar",
                                            textColor: "#ff5252",
                                            show: true,
                                        },
                                        {
                                            icone: "ios-git-merge",
                                            label: "Associar",
                                            textColor: "#00bcd4",
                                            show: true,
                                        }
                                    ].filter(ticket => {
                                        return !(ticket.label === "Associar" && params.row.associacoes_count > 0);
                                    }),
                                }
                            });
                        }
                    }
                ],
                pgd_mvp_colunas: [
                    {
                        title: "#",
                        key: "id_ticket",
                        width: 100,
                        render: (h, params) => {
                            return h({
                                template: `<span class="content-column">
                                    <Tooltip placement="top" style="font-size:11px" content="ID Ticket">
                                        <Tag class="tag-ticket">${params.row.id_ticket}</Tag>
                                    </Tooltip>
                                    <Tooltip v-if="${params.row.movidesk_id}" placement="top" style="font-size:11px" content="ID Movidesk">
                                        <Tag class="tag-ticket">${params.row.movidesk_id}</Tag>
                                    </Tooltip>
                                </span>`
                            });
                        }
                    },
                    {
                        title: "Resumo",
                        key: "resumo",
                        render: (h, params) => {
                            return h(
                                "div",
                                {
                                    style: {
                                        fontSize: "16px"
                                    }
                                },
                                [
                                    h(
                                        "a",
                                        {
                                            attrs: {
                                                class: "table-edit"
                                            },
                                            on: {
                                                click: () =>
                                                    this.editTicket(
                                                        params.row.id_ticket
                                                    )
                                            }
                                        },
                                        [
                                            params.row.resumo,
                                            h("Icon", {
                                                props: {
                                                    type: "md-create"
                                                }
                                            })
                                        ]
                                    )
                                ]
                            );
                        }
                    },
                    {
                        title: "Projeto",
                        key: "projeto_nome",
                        width: 120
                    },
                    {
                        title: "Peso",
                        key: "peso",
                        width: 65,
                        render: (h, params) => {
                            return h("Tag", params.row.peso);
                        }
                    },
                    {
                        title: "Prazo",
                        key: "data_hora_cadastro",
                        width: 100,
                        render: (h, params) => {
                            return h(
                                "div",
                                moment(params.row.data_hora_cadastro).format(
                                    "DD/MM/YYYY"
                                )
                            );
                        }
                    },
                    {
                        title: "Tela",
                        key: "tela_ux",
                        width: 60,
                        render: (h, params) => {
                            return h(
                                "a",
                                {
                                    on: {
                                        click: () =>
                                            this.pgdTelaUx(params.row.id_ticket)
                                    }
                                },
                                [
                                    h("Icon", {
                                        props: {
                                            type:
                                                params.row.tela_ux == 1
                                                    ? "ios-color-palette"
                                                    : "ios-color-palette-outline"
                                        },
                                        style: {
                                            fontSize: "22px",
                                            color: "#515a73"
                                        }
                                    })
                                ]
                            );
                        }
                    }
                ],
                labels: {
                    mel: h => {
                        return h("span", [
                            "Melhorias",
                            h("Badge", {
                                props: {
                                    count: this.totais_quarentena[33] || 0,
                                    type: "warning",
                                    overflowCount: 9999
                                },
                                style: {
                                    marginLeft: "5px"
                                }
                            })
                        ]);
                    },
                    mvp: h => {
                        return h("span", [
                            "MVP",
                            h("Badge", {
                                props: {
                                    count: this.totais_quarentena[45] || 0,
                                    type: "success",
                                    overflowCount: 9999
                                },
                                style: {
                                    marginLeft: "5px"
                                }
                            })
                        ]);
                    }
                },
                tickets: [], // Todos
                tickets_pgd: [],
                tickets_quarentena_mvp: [],
                tickets_quarentena_mel: [],
                tickets_quarentena_ss: [],
                totais_quarentena: {}, // {33: 12, 35: 0, 45: 6...}
                tipos: {
                    tickets_pgd: {
                        status: 1
                    },
                    tickets_quarentena_mel: {
                        status: 0,
                        tipo_id: 33,
                        page: 1,
                        more: true,
                    },
                    tickets_quarentena_ss: {
                        status: 0,
                        tipo_id: 35,
                        page: 1,
                        more: true,
                    },
                    tickets_quarentena_mvp: {
                        status: 0,
                        tipo_id: 45,
                        page: 1,
                        more: true,
                    },
                },
                defaultOrder: {
                    tickets_quarentena_mel: { key: 'posicao', dir: 'asc'},
                    tickets_quarentena_ss: { key: 'posicao', dir: 'asc'},
                },
                show_andamento:false,
                carregar:false,
                andamento:{
                    id:null,
                    titulo:null,
                    descricao:null,
                    causa_titulo:null,
                    tipo_id:null,
                    sistema_id:null,
                    funcionalidade:null,
                },
            };
        },
        created() {
            this.$Spin.show();
            this.getTickets();
        },
        methods: {
            searchDelay: _.debounce(function (val) {
                if (this.filtro.search !== val) {
                    this.filtro.search = val;
                    this.getTicketsQuarentena(this.filtro.search);
                }
            }, 1000),
            /**
             * Responsável pela paginação dos tickets
             */
            async loadMore(nome_colecao) {
                if (!this.tipos[nome_colecao].more) return;
                this.$Spin.show();
                try {
                    this.tipos[nome_colecao].page++;
                    const tickets = await this.getTicketsPorTipo(nome_colecao, this.filtro.search, this.tipos[nome_colecao].page);
                    this.tickets = this.tickets.concat(tickets);
                    this.organizarTickets();
                    this.$Spin.hide();
                } catch (ex) {
                    console.warn(ex);
                    this.$Spin.hide();
                }
            },
            async getTickets() {
                this.$Spin.show();
                try {
                    const URI = `ticket?status=1&sort=posicao&with=projeto`;
                    const {data: {data}} = await this.$axios.get(URI);
                    this.tickets_pgd = data;
                    this.getTicketsQuarentena(this.filtro.search);
                } catch (ex) {
                    console.warn(ex);
                }
            },
            async getTicketsPorTipo(nome_colecao, query, page = 1) {
                const tipo_id = this.tipos[nome_colecao].tipo_id;
                let URI;
                if (nome_colecao === 'tickets_quarentena_mvp') {
                    URI = `ticket/mvps?status=0&query=${query}&page=${page}&with=projeto`;
                } else if (nome_colecao === 'tickets_quarentena_mel') {
                    URI = `ticket?status=0&tipo_id=${tipo_id}&query=${query}&page=${page}&with=associacoes_count&sort=valor_mensalidades&dir=desc`;
                } else {
                    URI = `ticket?status=0&tipo_id=${tipo_id}&query=${query}&page=${page}&sort=posicao`;
                }
                const {data: {data, meta}} = await this.$axios.get(URI);
                this.totais_quarentena[tipo_id] = meta.total;
                this.tipos[nome_colecao].more = (meta.current_page !== meta.last_page);
                return data;
            },
            async getTicketsQuarentena(query, page = 1) {
                this.$Spin.show();
                try {
                    const tickets_mel = await this.getTicketsPorTipo('tickets_quarentena_mel', query, page);
                    const tickets_ss = await this.getTicketsPorTipo('tickets_quarentena_ss', query, page);
                    const tickets_mvp = await this.getTicketsPorTipo('tickets_quarentena_mvp', query, page);

                    if (page === 1) {
                        this.tickets = this.tickets_pgd.concat(tickets_mel, tickets_ss, tickets_mvp);
                    } else {
                        this.tickets = this.tickets.concat(this.tickets_pgd, tickets_mel, tickets_ss, tickets_mvp);
                    }
                    this.organizarTickets();
                    this.$Spin.hide();
                } catch (ex) {
                    console.warn(ex);
                    this.$Spin.hide();
                }
            },
            /**
             * Atualiza a ordem da lista de PGDs de acordo com sua posição
             */
            organizarTickets() {
                const tickets = this.tickets.filter(item => item.ativo == 1);

                this.tickets = _.orderBy(tickets, ["posicao"], ["asc"]);
                /**
                 * Separa a Quarentena por Tipo
                 */
                this.organizarTicketsPgd();
                this.organizarQuarentenaMvp();
                this.organizarQuarentenaMel();
            },
            onDrop(nome_colecao, dropResult) {
                let {removedIndex, addedIndex, payload} = dropResult;

                if (removedIndex === null && addedIndex === null) return;

                /**
                 * Array que está sendo removido/adicionado
                 */
                const collection = this[nome_colecao];

                /**
                 * Array com todos os elementos
                 */
                let result = this.tickets;
                let itemToAdd = payload;

                // 32: Bugs não podem ser movidos para quarentena
                if (itemToAdd.tipo_id === 32 && (removedIndex === null || addedIndex === null)) return;

                /**
                 * Coleção de Destino
                 */
                if (addedIndex !== null) {
                    const novo_status = this.tipos[nome_colecao].status;
                    let pos_atual = parseInt(itemToAdd.posicao);
                    let pos_nova = parseInt(_(result).last().posicao); //Última posição da coleção
                    /**
                     * Busco a posição original do elemento que está sendo adicionado no array que possui todos os elementos
                     */
                    let removedIndexPGD = result.findIndex(
                        (element) => element.id_ticket === itemToAdd.id_ticket
                    );

                    itemToAdd = result.splice(removedIndexPGD, 1)[0];
                    let addedIndexGeral = 0;
                    if (collection.length) {
                        pos_nova = parseInt(collection[addedIndex].posicao);
                        /**
                         * Busco a posição original do elemento que será substituido
                         */
                        addedIndexGeral = result.findIndex(
                            (element) => element.id_ticket === collection[addedIndex].id_ticket
                        );
                        /**
                         * Caso esteja sendo movimentado de uma coleção a outra, altero a posição, relativa ao arraste do Ticket
                         */
                        if (
                            itemToAdd.status !== novo_status &&
                            itemToAdd.posicao < collection[addedIndex].posicao
                        ) {
                            addedIndexGeral--;
                            pos_nova = parseInt(result[addedIndexGeral].posicao);
                        }
                    }

                    /**
                     * Atualiza o totalizador que é exibido nos tickets em quarentena
                     */
                    if (itemToAdd.status !== novo_status) {
                        const tipo_id = itemToAdd.tipo_id;
                        if (novo_status === 0) {
                            if (this.totais_quarentena[tipo_id]) {
                                this.totais_quarentena[tipo_id]++;
                            } else {
                                this.totais_quarentena[tipo_id] = 1;
                            }
                        } else {
                            this.totais_quarentena[tipo_id]--;
                        }
                    }

                    /**
                     * Atualizo o status do elemento (quarentena, melhoria, ticket)
                     */
                    itemToAdd.status = novo_status;
                    itemToAdd.posicao = pos_nova;
                    this.atualizarPosicaoDB(
                        itemToAdd.id_ticket,
                        itemToAdd.status,
                        pos_nova,
                        pos_atual
                    );
                    result = this.atualizarPosicao(result, pos_nova, pos_atual);
                    result.splice(addedIndexGeral, 0, itemToAdd);
                }
                this.tickets = result;
                this.organizarTickets();
            },
            atualizarPosicao(arr, pos_nova, pos_atual) {
                return arr.map(item => {
                    if (pos_nova > pos_atual) {
                        item.posicao -= item.posicao > pos_atual && item.posicao <= pos_nova ? 1 : 0;
                    } else {
                        item.posicao += item.posicao < pos_atual && item.posicao >= pos_nova ? 1 : 0;
                    }
                    return item;
                });
            },
            async atualizarPosicaoDB(id_ticket, status, pos_nova, pos_atual) {
                try {
                    const URI = `ticket/${id_ticket}/atualizarPosicao`;
                    await this.$axios.put(URI, {
                        status,
                        pos_nova,
                        pos_atual
                    });
                } catch (error) {
                    console.warn(error);
                }
            },
            organizarTicketsPgd() {
                /**
                 * Separa os PGDs que estão listados para desenvolvimento
                 */
                const tickets_pgd = this.tickets.filter(item => (item.status === 1));

                this.tickets_pgd = _.orderBy(tickets_pgd, ["posicao"], ["asc"]);
            },
            organizarQuarentenaMvp() {
                let mvps = this.tickets
                    .filter(item => (item.status === 0 && item.tipo_id === 45 && item.projeto))
                    .map(mvp => {
                        mvp.projeto_nome = mvp.projeto.nome;
                        mvp.proj_posicao = mvp.projeto.posicao;
                        return mvp;
                    }, this);
                mvps = _.orderBy(
                    mvps,
                    ["proj_posicao", "posicao"],
                    ["asc", "asc"]
                );
                /**
                 * Permite o arraste apenas do primeiro MVP de cada projeto
                 */
                let projeto_anterior = 0;
                this.tickets_quarentena_mvp = mvps.map(item => {
                    item.block_drag = !(item.projeto_id !== projeto_anterior);
                    projeto_anterior = item.projeto_id;
                    return item;
                });
            },
            organizarQuarentenaMel() {
                let mel = this.tickets.filter(item => (item.status === 0 && item.tipo_id === 33))
                    .map(item => {
                        item.valor_mensalidades = parseFloat(item.valor_mensalidades);
                        return item;
                    });
                this.tickets_quarentena_mel = _.orderBy(
                    mel,
                    ["valor_mensalidades"],
                    ["desc"]
                );
            },
            getChildPgd: function (index) {
                return this.tickets_pgd[index];
            },
            getTicketQuarentenaMvp: function (index) {
                return this.tickets_quarentena_mvp[index];
            },
            getTicketQuarentenaMel: function (index) {
                return this.tickets_quarentena_mel[index];
            },
            getIconTicket: (id, criticidade) => {
                const icons = {
                    32: "ios-bug",
                    33: "ios-star",
                    45: "ios-flash"
                };

                const colors = {
                    32: ["#F2ABAB", "#F2ABAB", "#E65757", "#D90000"],
                    33: ["#FFE8B6", "#FFE8B6", "#FFD06D", "#FFB822"],
                    45: ["#C8CDF4", "#C8CDF4", "#919BE9", "#5867DD"],
                };

                return {
                    type: icons.hasOwnProperty(id) ? icons[id] : "",
                    color: colors.hasOwnProperty(id) ? colors[id][criticidade] : "#36A3F7",
                }
            },
            /**
             * Abre o drawer para edição do ticket
             */
            editTicket(id_ticket) {
                this.edit_id = id_ticket;
                this.edit_pgd = true;
            },
            /**
             * Após editar o ticket, atualizo os dados do ticket na lista de tickets
             */
            onTicketUpdate(ticket) {
                const idx = _.findIndex(
                    this.tickets,
                    o => o.id_ticket == ticket.id_ticket
                );

                this.tickets.splice(idx, 1, ticket);
                this.organizarTickets();
            },
            onSort(nome_colecao, key, dir) {
                const defaultOrder = this.defaultOrder[nome_colecao];
                // Reset Order
                if (defaultOrder && defaultOrder.key === key && defaultOrder.dir === dir) {
                    key = 'posicao';
                    dir = 'asc';
                }
                this[nome_colecao] = _.orderBy(this[nome_colecao], [key], [dir]);

                // Para exibir o highlight
                this.defaultOrder[nome_colecao] = {key, dir};
            },
            async pgdAnaliseGestao(id_ticket) {
                const idx_pgd = _.findIndex(
                    this.tickets,
                    o => o.id_ticket == id_ticket
                );
                const analise_gestao = parseInt(
                    this.tickets[idx_pgd].analise_gestao
                );
                this.tickets[idx_pgd].analise_gestao = 1 - analise_gestao;
                try {
                    const URI = `ticket/${id_ticket}`;
                    await this.$axios.put(URI, {
                        analise_gestao: 1 - analise_gestao
                    });
                } catch (ex) {
                    console.warn(ex);
                    this.tickets[idx_pgd].analise_gestao = analise_gestao;
                }
            },
            async pgdTelaUx(id_ticket) {
                const idx_pgd = _.findIndex(
                    this.tickets,
                    o => o.id_ticket == id_ticket
                );
                const tela_ux = parseInt(this.tickets[idx_pgd].tela_ux);
                this.tickets[idx_pgd].tela_ux = 1 - tela_ux;
                try {
                    const URI = `ticket/${id_ticket}`;
                    await this.$axios.put(URI, {
                        tela_ux: 1 - tela_ux
                    });
                } catch (ex) {
                    console.warn(ex);
                    this.tickets[idx_pgd].tela_ux = tela_ux;
                }
            },
            async opcaoTicket(id, opcao) {
                const idx = this.tickets.findIndex(o => o.id_ticket === id);
                const ticket = this.tickets[idx];
                try {
                    if (opcao === "Associar") {
                        const {id_associado} = await this.associarTicket(ticket);
                        /**
                         * Remove o ticket da listagem
                         */
                        if (idx > -1) {
                            this.tickets.splice(idx, 1);
                        }
                        const idx_ass = this.tickets.findIndex(o => o.id_ticket === id_associado);
                        if (idx_ass !== -1) {
                            this.tickets[idx_ass].associacoes_count += 1;
                        }
                        this.organizarTickets();
                    } else if (opcao === "Fechar") {
                        this.edit_id = idx
                        this.andamento.tipo_id = null
                        this.andamento.funcionalidade = ticket.funcionalidade
                        this.show_andamento = true
                        this.andamento.titulo = `Fechando Ticket ${id} (${ticket.resumo.substring(0, 15)}...)`
                        this.andamento.descricao = `Observação`
                    }
                } catch ({error, observacao}) {
                    console.warn(error);
                    this.$Message.error(`Erro! ${error}`);
                    this.tickets[idx].observacao = observacao;
                }
            },
            /**
              Quando o ticket passar por alteração no andamento é feito um update nas informações
            */
            async updateAndamento(form){
                const id = this.edit_id
                const ticket = this.tickets[id]
                try {
                    await this.fecharTicket(ticket,form)
                    /**
                     * Remove o ticket da listagem
                    */
                    if (id > -1) {
                        this.tickets.splice(id, 1);
                    }
                    this.organizarTickets();
                } catch (error) {
                    console.warn(error);
                    this.$Message.error(`Erro! ${error}`)
                }
            },
        },
    };
</script>

<style scoped>

    .table-draggable .table-row {
        padding: 0px 17px;
        cursor: move;
        display: flex !important;
    }

    .table-draggable .table-row.block-drag {
        cursor: default;
    }

    .table-draggable .table-header-row {
        padding: 15px 17px;
    }
</style>
<style>
    .quarentena.ivu-tabs {
        background-color: #fff;
    }

    .quarentena.ivu-tabs .ivu-tabs-bar {
        margin: 0;
        border: 1px solid #e8eaec;
        border-bottom: 0;
    }

    .quarentena.ivu-tabs .ivu-tabs-tab {
        padding: 13px 16px;
    }
</style>

